import { useEffect } from 'react';

const ATTRIBUTE_NAME = 'data-a11y-dialog-ignore-focus-trap';
const POPUP_CLASS_NAME = '.js_popup_all';
const MODAL_OPEN_CLASS_NAME = 'modal-open';

// NOTE: This hook is used to trap focus inside the popup when the popup is open
export const usePopupFocusTrap = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const updateFocusTrapAttribute = () => {
      const hasModalOpen = document.body.classList.contains(
        MODAL_OPEN_CLASS_NAME
      );
      const popupElements = document.querySelectorAll(POPUP_CLASS_NAME);

      popupElements.forEach((element) => {
        if (hasModalOpen) {
          element.setAttribute(ATTRIBUTE_NAME, '');
        } else {
          element.removeAttribute(ATTRIBUTE_NAME);
        }
      });
    };

    updateFocusTrapAttribute();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target === document.body
        ) {
          updateFocusTrapAttribute();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
      const popupElements = document.querySelectorAll(POPUP_CLASS_NAME);

      Array.from(popupElements).forEach((element) => {
        element.removeAttribute(ATTRIBUTE_NAME);
      });
    };
  }, [isOpen]);
};
